<template>
  <div>
    <p>正在跳转...</p>
  </div>
</template>

<script>
export default {
  name: 'Home',
  // 可以在这里添加 mounted 钩子作为备用跳转
  mounted() {
    window.location.href = 'https://www.wxhyshop.cn';
  }
}
</script>